import type { ReactNode } from 'react'

function RowLabel({ icon, label }: { icon: ReactNode; label: string }) {
  return (
    <span className="flex items-center gap-1 text-label font-medium text-black-100">
      {icon}
      <span>{label}</span>
    </span>
  )
}

export function DetailChipRow({
  icon,
  label,
  values,
  className = '',
}: {
  icon: ReactNode
  label: string
  values: string[]
  className?: string
}) {
  if (values.length === 0) return null

  return (
    <section className={`flex w-full flex-col gap-2.5 ${className}`}>
      <RowLabel icon={icon} label={label} />
      <div className="flex flex-wrap items-start gap-3">
        {values.map((text) => (
          <span
            key={text}
            className="inline-flex shrink-0 items-center justify-center rounded-lg border border-[rgb(0_0_0/10%)] bg-white-50 px-3 py-1 text-body-md font-medium whitespace-nowrap text-black-600"
          >
            {text}
          </span>
        ))}
      </div>
    </section>
  )
}

export function DetailInlineRow({
  icon,
  label,
  values,
  valueClass = 'text-body-md',
}: {
  icon: ReactNode
  label: string
  values: string[]
  valueClass?: string
}) {
  if (values.length === 0) return null

  return (
    <section className="flex w-full items-center gap-2">
      <RowLabel icon={icon} label={label} />
      <span className="ui-divider-v shrink-0" aria-hidden="true" />
      <span className={`flex flex-wrap items-center gap-1.5 font-medium text-black-600 ${valueClass}`}>
        {values.map((text, i) => (
          <span key={text} className="inline-flex items-center gap-1.5">
            {i > 0 && <span className="ui-dot" aria-hidden="true" />}
            <span>{text}</span>
          </span>
        ))}
      </span>
    </section>
  )
}
